import React from "react";
import Hero from "../Landing/Hero";
import ValueStrip from "../Landing/ValueStrip";
import RealWorld from "../Landing/RealWorld";
import Network from "../Landing/Network";
import TwoSides from "../Landing/TwoSides";
import BookingStory from "../Landing/BookingStory";
import FinalCta from "../Landing/FinalCta";
import "../../styles/Landing.css";

// The page is a sequence of chapters rather than one column of cards, and the
// order alternates ground and width on purpose -- white, warm, dark, split,
// warm, white -- so each section is sized by contrast with its neighbours
// instead of every one being the same box at the same width.
//
// Hero and ValueStrip are one white band: the strip is the hero's footer, and
// the first ground change is at RealWorld.
//
// --- what was cut, and why ------------------------------------------------
//
// Two sections are gone. Neither was badly made; both said something the page
// had already said.
//
//   * Product ("A campaign across a dozen screens is still one campaign")
//     was the same claim as Network ("One campaign. Many screens.") with a
//     dashboard attached. The strongest piece of that dashboard now floats on
//     Network's diagram, so the demonstration survived and the repetition did
//     not.
//
//   * PinkMoment ("One campaign. Many screens. The real world.") was a
//     full-bleed restatement of two headlines the visitor had already read.
//     It was the best-looking section on the page, which is exactly why it
//     took so long to notice that it carried no new information. Cutting it
//     makes the two lines it was echoing land harder.
//
// Every remaining section does one of four things: introduces an idea, shows
// the product, helps the visitor pick a side, or asks for the click.

export default function Landing() {
    return (
        <>
            <Hero />
            {/* Anchors the bottom of the hero and answers "what is this"
                in three lines -- the question the headline deliberately
                does not answer. */}
            <ValueStrip />
            <RealWorld />
            <Network />
            <TwoSides />
            <BookingStory />
            <FinalCta />
        </>
    );
}
